import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitContact = (payload) => axios.post(`${API}/contact`, payload);

export const adminLogin = async (key) => {
  const res = await axios.get(`${API}/admin/stats`, { headers: { "X-Admin-Key": key } });
  return res.data;
};

export const fetchContacts = (key) =>
  axios.get(`${API}/admin/contacts`, { headers: { "X-Admin-Key": key } });

export const fetchStats = (key) =>
  axios.get(`${API}/admin/stats`, { headers: { "X-Admin-Key": key } });

export const updateContactStatus = (key, id, status) =>
  axios.patch(`${API}/admin/contacts/${id}?status=${status}`, {}, { headers: { "X-Admin-Key": key } });
export const deleteContact = (key, id) =>
  axios.delete(`${API}/admin/contacts/${id}`, { headers: { "X-Admin-Key": key } });

// ---------- Public content ----------
const langQ = (lang) => (lang ? `?lang=${lang}` : "");
export const fetchBlog = (lang) => axios.get(`${API}/blog${langQ(lang)}`);
export const fetchBlogPost = (slug) => axios.get(`${API}/blog/${encodeURIComponent(slug)}`);
export const fetchCases = (lang) => axios.get(`${API}/case-studies${langQ(lang)}`);
export const fetchCase = (slug) => axios.get(`${API}/case-studies/${encodeURIComponent(slug)}`);
export const fetchTeam = () => axios.get(`${API}/team`);
export const fetchTestimonials = (lang) => axios.get(`${API}/testimonials${langQ(lang)}`);
export const fetchFaqs = (lang) => axios.get(`${API}/faqs${langQ(lang)}`);
export const fetchAchievements = () => axios.get(`${API}/achievements`);
export const fetchJobs = (lang) => axios.get(`${API}/jobs${langQ(lang)}`);
export const fetchMilestones = (lang) => axios.get(`${API}/milestones${langQ(lang)}`);
export const fetchPartners = () => axios.get(`${API}/partners`);
export const fetchCertifications = () => axios.get(`${API}/certifications`);
export const fetchVideoTestimonials = (lang) => axios.get(`${API}/video-testimonials${langQ(lang)}`);
export const submitJobApplication = (fd) =>
  axios.post(`${API}/careers/apply`, fd, { headers: { "Content-Type": "multipart/form-data" } });
export const fetchResources = (lang) => axios.get(`${API}/resources${langQ(lang)}`);
export const downloadResource = (payload) => axios.post(`${API}/resources/download`, payload);
export const fetchGallery = (lang) => axios.get(`${API}/gallery${langQ(lang)}`);
export const fetchBookingSlots = (date) => axios.get(`${API}/bookings/slots`, { params: { date } });
export const createBooking = (data) => axios.post(`${API}/bookings`, data);
export const adminListBookings = (key) => axios.get(`${API}/admin/bookings`, authCfg(key));
export const adminUpdateBooking = (key, id, data) => axios.put(`${API}/admin/bookings/${id}`, data, authCfg(key));
export const adminDeleteBooking = (key, id) => axios.delete(`${API}/admin/bookings/${id}`, authCfg(key));
export const submitTicket = (data) => axios.post(`${API}/tickets`, data);
export const adminListTickets = (key) => axios.get(`${API}/admin/tickets`, authCfg(key));
export const adminUpdateTicket = (key, id, data) => axios.put(`${API}/admin/tickets/${id}`, data, authCfg(key));
export const adminDeleteTicket = (key, id) => axios.delete(`${API}/admin/tickets/${id}`, authCfg(key));
export const fetchSettings = () => axios.get(`${API}/settings`);
export const subscribeNewsletter = (email) => axios.post(`${API}/newsletter`, { email });

export const toAbsolute = (url) => (url && url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url);

export const uploadImage = (key, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/admin/upload`, fd, { headers: { "X-Admin-Key": key, "Content-Type": "multipart/form-data" } });
};

// ---------- Admin content CRUD ----------
const authCfg = (key) => ({ headers: { "X-Admin-Key": key } });
export const adminList = (key, res) => axios.get(`${API}/admin/${res}`, authCfg(key));
export const adminCreate = (key, res, data) => axios.post(`${API}/admin/${res}`, data, authCfg(key));
export const adminUpdate = (key, res, id, data) => axios.put(`${API}/admin/${res}/${id}`, data, authCfg(key));
export const adminDelete = (key, res, id) => axios.delete(`${API}/admin/${res}/${id}`, authCfg(key));
export const fetchSubscribers = (key) => axios.get(`${API}/admin/newsletter`, authCfg(key));
export const deleteSubscriber = (key, id) => axios.delete(`${API}/admin/newsletter/${id}`, authCfg(key));
export const updateSettings = (key, data) => axios.put(`${API}/admin/settings`, data, authCfg(key));
export const previewEmail = (key) => axios.post(`${API}/admin/preview-email`, {}, authCfg(key));
